module.exports = __webpack_public_path__ + "static/media/close_wht.49c20463.svg";